class HeaderImage {
	constructor(element) {
		this.element = element;
		this.src = element.dataset.src ?? null;

		console.log({
			element: this.element,
			src: this.src
		})

		if (this.src) {
			setTimeout(this.init.bind(this), 1000);
		}
	}

	init() {
		const image = document.createElement("img");

		image.addEventListener("load", () => {
			const picture = document.createElement("picture");
			picture.classList.add("aos-init", "aos-animate");
			picture.setAttribute("data-aos", "fade");
			picture.setAttribute("data-aos-delay", "400");
			picture.setAttribute("id", "page-header__image");

			image.style.aspectRatio = `${image.width} / ${image.height}`;
			image.classList.add("lazyautosizes", "lazyloaded");
			image.setAttribute("height", image.height);
			image.setAttribute("width", image.width);
			image.setAttribute("alt", "");

			picture.insertAdjacentElement("afterbegin", image);
			this.element.insertAdjacentElement("afterbegin", picture);
		}, {once: true});

		image.src = this.src;
	}
}

export default HeaderImage
